<!--
Author: TangChen
Date: 2018-12-25
Desc: 用户购买专户理财或私募产品页面
 -->
<template>
    <div :class="'bizcomp-private-buy bizcomp ' + className">
        <comp-title :title="title">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/privatefund' }">
                    专户理财
                </el-breadcrumb-item>
                <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title>
        <div class="fund-market">
            <el-table v-show="!buySuccess" :data="fundAll" style="width: 100%" :show-header="false">
                <el-table-column label="基金信息">
                    <template slot-scope="scope">
                        <el-row class="fund-list">
                            <el-col :span="24" class="fund-tit">
                                <span>{{ scope.row.fundname+'('+(scope.row.fundcode === "515981" ? "515980" : scope.row.fundcode)+')' }}<i
                                    class="risk"
                                    :class="$util.riskCla(scope.row.risklevel)"
                                >{{ $cache.getDict('110143',scope.row.risklevel)+'风险' }}</i></span>
                            </el-col>
                            <el-col :span="5">
                                <span class="big" :class="scope.row.annualincome>0?'add':(scope.row.annualincome<0?'reduce':'')">{{ $util.fmtNum(scope.row.annualincome) }}%</span>
                                <p>预计年化收益</p>
                            </el-col>
                            <el-col :span="5">
                                <span>{{ scope.row.deadline?scope.row.deadline:'--' }}</span>
                                <p>投资期限</p>
                            </el-col>
                            <el-col :span="5">
                                <span>{{ $util.fmtNum(parseFloat(scope.row.minamount)/10000) }}</span>
                                <p>投资起点(万元)</p>
                            </el-col>
                            <el-col :span="5">
                                <span>{{ $cache.getDict('100017',scope.row.risklevel) }}</span>
                                <p>适合人群</p>
                            </el-col>
                            <el-col :span="4">
                                <span>{{ $cache.getDict('130011',scope.row.fundstatus) }}</span>
                                <p>产品状态</p>
                            </el-col>
                        </el-row>
                    </template>
                </el-table-column>
            </el-table>
            <el-form
                v-show="!buySuccess"
                ref="fundInfo"
                :model="fundInfo"
                :rules="rules"
                label-width="260px"
                class="pwdForm"
                inline-message
                v-on:submit.native.prevent
            >
                <el-form-item label="募集进度：" class="form-text">
                    <div class="text-con">
                        <el-progress
                            class="private-progress"
                            :percentage="Number(fund.soldprogress?fund.soldprogress*100:0)"
                            color="#67c23a"
                            :stroke-width="10"
                            :show-text="false"
                        />
                        <span class="progress-text">已完成：<span>{{ $util.fmtNum(fund.soldprogress*100) }}%</span></span>
                        <span class="progress-text">剩余额度：<span v-cloak class="red">{{ fund.remainder }}</span></span>
                    </div>
                </el-form-item>
                <el-form-item v-if="fund.payway" label="支付方式：" prop="way" class="form-text">
                    <el-radio-group v-model="fundInfo.way">
                        <el-radio v-if="fund.payway.indexOf('1')>-1" label="1" name="sell">
                            现金宝<span>(可用余额：<span
                                class="red"
                            >{{ $util.fmtNum(xjbAll) }}</span>元)</span>
                        </el-radio>
                        <el-radio v-if="fund.payway.indexOf('2')>-1" label="2" name="sell">
                            银行卡
                        </el-radio>
                        <el-radio v-if="fund.payway.indexOf('3')>-1" label="3" name="sell">
                            汇款
                        </el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="支付渠道：" prop="pay" class="payway-list">
                    <el-select
                        v-if="fundInfo.way!=='1' && bankLists.length > 0"
                        v-model="fundInfo.pay"
                        placeholder="请选择支付方式"
                        :class="{'hasVal':bankInfo && bankInfo.label}"
                        v-on:change="bankSel"
                    >
                        <el-option-group
                            v-for="(group,index) in bankLists"
                            :key="index"
                            :label="group.label"
                            class="bank-sel"
                        >
                            <el-option
                                v-for="item in group.options"
                                :key="item.moneyaccount"
                                :label="item.label"
                                :value="item.moneyaccount"
                            >
                                <div v-if="!item.bankAdd" class="bank-info">
                                    <img :src="$util.getImg(item.bankid)">
                                    <span>{{ item.label }}</span>
                                    <p v-if="!item.bankAdd">
                                        {{ item.text }}
                                    </p>
                                </div>
                                <div v-if="item.bankAdd" class="option-group clear">
                                    {{ item.bankCate }}<el-button
                                        type="blue"
                                        v-on:click.prevent="$router.push({name:'addbank'})"
                                    >
                                        {{ item.bankAdd }}
                                    </el-button>
                                </div>
                            </el-option>
                        </el-option-group>
                    </el-select>
                    <div v-if="fundInfo.way!=='1' && bankInfo && bankInfo.label" class="el-select-img">
                        <img
                            :src="$util.getImg(bankInfo.bankid)"
                        >
                        <span class="k-text-flow">{{ bankInfo.label }}</span>
                    </div>
                    <el-radio-group v-if="(fundInfo.way==='1' && xjbInfo.length===0)||((fundInfo.way==='2' || fundInfo.way==='3') && bankLists.length === 0)" class="bank-radio">
                        <el-radio label="no-selec" border>
                            <div class="bank-img-sel">
                                <div v-if="fundInfo.way==='1'" class="k-text-flow">
                                    您的现金宝还未充值，请立即<span
                                        class="like-a"
                                        v-on:click="$router.push({name:'currencycharge'})"
                                    >前往充值</span>
                                </div>
                                <div v-else class="k-text-flow">
                                    您还未添加银行卡，请立即<span
                                        class="like-a"
                                        v-on:click="$router.push({name:'bank'})"
                                    >前往添加</span>
                                </div>
                            </div>
                        </el-radio>
                    </el-radio-group>
                    <el-radio-group
                        v-if="fundInfo.way==='1' && xjbInfo.length>0"
                        v-model="fundInfo.pay"
                        class="bank-radio"
                    >
                        <el-radio
                            v-for="bank in xjbInfo"
                            :key="bank.transid+bank.xjbfundcode"
                            :label="bank.transid+bank.xjbfundcode"
                            border
                        >
                            <div class="bank-img-sel">
                                <img :src="$util.getImg(bank.bankid)">
                                <div class="k-text-flow">
                                    <span class="bank-name" :title="$cache.getDict('150003',bank.bankid)">{{ $cache.getDict('150003',bank.bankid).toString().substr(0,6) }}</span>总额(元):<span
                                        class="bank-balance"
                                    >{{ $util.fmtNum(bank.totalasset) }}</span>
                                </div>
                                <i class="el-icon-check" />
                            </div>
                        </el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item v-show="fund.sharetype === 'A,B'" label="收费方式：" prop="way" class="form-text">
                    <el-radio-group v-model="fundInfo.sharetype">
                        <el-radio label="A" name="share">
                            前收费
                        </el-radio>
                        <el-radio label="B" name="share">
                            后收费
                        </el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="购买金额：" prop="amount" class="redemp-amount" :class="{'form-text':fund.sign&&!isPwdCheck}">
                    <el-input
                        v-model.trim="fundInfo.amount"
                        class="prefix"
                        :placeholder="pla"
                        :maxlength="14"
                        prefix-icon="fa fa-jpy"
                    />
                    <p class="redemp-prompt">
                        <i class="el-icon-warning" /><span>{{ fund.fundtype
                            === '2'?'货币基金零费率':('买入费率' + fund.feerate) }}</span><span v-if="fund.isBuy===''">{{ '，预计'
                            + $util.fmtDate(fund.cfmdate) }}确认份额</span>
                    </p>
                </el-form-item>
                <!-- <el-form-item v-show="feeGate.charge" label="预估手续费：" class="form-text">
                    <div class="text-con" v-html="feeH" />
                </el-form-item> -->
                <el-form-item v-if="isPwdCheck" label="交易密码：" prop="pwd" :class="{'form-text':fund.sign}">
                    <el-input
                        v-model.trim="fundInfo.pwd"
                        type="password"
                        placeholder="请输入交易密码"
                        :maxlength="16"
                    />
                    <span class="redemp-btn"><span class="like-a">忘记密码？</span></span>
                </el-form-item>
                <el-form-item>
                    <div style="width:50%;">
                        <el-button
                            type="primary"
                            class="medium"
                            :disabled="time>0 || errStatus || (fundInfo.way==='1' && xjbInfo.length===0)||((fundInfo.way==='2' || fundInfo.way==='3') && bankLists.length === 0)"
                            v-on:click="submitInfo('fundInfo')"
                        >
                            立即购买
                        </el-button>
                        <el-button class="medium" :disabled="errStatus" v-on:click="$router.back()">
                            返回
                        </el-button>
                    </div>
                </el-form-item>
            </el-form>
        </div>
        <fund-protocol v-if="!buySuccess" v-model="protocol" :fund="fund" v-on:all-read="buyFund" />
        <result v-if="buySuccess" :active="2" :result="result" v-on:return-page="reset" v-on:return-login="$router.push({name:'traderecord'})" />
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import result from "@/components/layout/result";
import fundProtocol from "@/components/form/fundProtocol";
export default {
    name: "PrivateBuy",
    components: {
        result,
        fundProtocol
    },
    mixins: [mixin],
    data () {
        return {
            feeH: "", // 费率信息
            fundAll: [],
            activeName: "",
            // 表单信息
            fundInfo: {
                amount: "",
                way: "",
                pay: "",
                sharetype: "",
                pwd: ""
                // protocol: ""
            },
            protocol: false,
            rules: {// 校验规则配置
                amount: [
                    { validator: this.amountLimit, trigger: "blur" }
                ],
                pay: [
                    { validator: this.validatePayWay, trigger: "change" }
                ],
                pwd: [
                    { required: true, message: "请输入交易密码", trigger: "blur" }
                ]
            },
            result: {// 结果页面信息
                cla: "register-success",
                msg: "您的购买申请已提交成功！",
                btnMsg: "预计11月30日以11月29日净值确认份额，如遇节假日则顺延，请耐心等待",
                special: false,
                btnL: {
                    text: "继续购买",
                    event: "return-page"
                },
                btnR: {
                    text: "查看交易记录",
                    event: "return-login"
                }
            },
            feeGate: {},
            query: null,
            xjbSel: {}, // 选中现金宝
            xjbAll: "", // 现金宝总资产
            xjbInfo: [], // 现金宝信息
            time: 0, // 发送短信倒计时
            fund: {}, // 基金信息获取
            bankLists: [], // 银行卡列表
            limit: { text: "起购金额范围为：", min: "0", max: "0" }, // 限额
            bankInfo: {}, // 校验银行卡信息
            cfmdate: "", // 确认日期
            isPwdCheck: false, // 是否校验密码
            checkMobile: false, // 短信鉴权验证码显示开关
            pla: "请输入起购金额",
            buySuccess: false, // 购买状态
            isPwdCheck2: false,
            errStatus: false
        };
    },
    watch: {
        "fundInfo.amount" (val) {
            this.isAmount(val);
        },
        "fundInfo.way" (val) {
            this.fundInfo.pay = "";
            if (val === "1") {
                this.fundInfo.pay = this.xjbInfo[0] ? (this.xjbInfo[0].transid + this.xjbInfo[0].xjbfundcode) : "";
            } else {
                this.getBank();
            }
        },
        "fundInfo.sharetype" (val) {
            if (val === "B") {
                this.feeGate = {};
            }
        },
        "fundInfo.pay" (val) {
            if (this.fundInfo.way === "1") {
                const _x = this.xjbInfo.filter(item => {
                    return item.transid + item.xjbfundcode === val;
                })[0];
                if (_x) {
                    this.xjbSel = _x;
                    const _l = Number(_x.totalasset) > Number(this.fund.xjbmax) ? this.fund.xjbmax : _x.totalasset;
                    this.$set(this.limit, "min", this.fund.xjbmin);
                    this.$set(this.limit, "max", _l);
                } else {
                    this.$set(this.limit, "min", "0");
                    this.$set(this.limit, "max", "0");
                }
                this.pla = this.$util.fmtNum(this.limit.min) + "元起，最多可投" + this.$util.fmtNum(this.limit.max) + "元";
                this.queryRate();
            }
        }
    },
    created () {
        this.getInvestorCheck();
        this.fund = JSON.parse(sessionStorage.getItem(this.$route.name));
        this.isPwdCheck = this.$cache.getPwdCheck(this.fund.way);
        // this.getBuyWay();
        this.fundAll.push(this.fund);
    },
    methods: {
        getInvestorCheck () {
            this.isPwdCheck2 = this.$cache.getPwdCheck("X1");
            let divcontent = "";
            let _this = this;
            this.$req({method: "GET", url: "pef/investor/check", timeout: 20000, data: {}}).then(res => {
                if (res.code === "0000000") {
                    if(res.record[0][0].buyspecialflag === "0") {
                        if (res.record[0][0].appstatus === "1") {
                            _this.$alert("您所提交的资料正在审核中，请一段时间后重新尝试购买!", "", {
                                confirmButtonText: "确定",
                                type: "info",
                                callback: action => {
                                    _this.$router.back();
                                }
                            });
                            return false;
                            /* _this.$message({
                                type: "info",
                                message: "您所提交的资料正在审核中，请一段时间后重新尝试购买",
                                onClose: function () {
                                }
                            });
                            _this.$router.back();
                            return false; */
                        }
                        if (res.record[0][0].appstatus === "2") {
                            _this.$message({
                                type: "info",
                                message: "您还没有提交合格投资者转换所需文件资料，3秒后跳转到转换资料上传页面",
                                onClose: function () {
                                    _this.$router.push({ name: "invdataup", query: {flag: "1"} });
                                }
                            });
                            return false;
                        }
                        divcontent = _this.isPwdCheck2 ? "<div><input id='privatePwd' type='password' placeholder='请输入交易密码' :maxlength='16' class='dialog-pwd' /></div>" : "";
                        _this.$alert("非合格投资者，或投资者转换申请审核失败，不能购买专户产品" + divcontent, "提示", {
                            confirmButtonText: "转换为合格投资者",
                            dangerouslyUseHTMLString: true,
                            type: "warning",
                            center: true,
                            callback: action => {
                                if (action === "confirm") {
                                    if (_this.isPwdCheck2 && !document.getElementById("privatePwd").value) {
                                        _this.$message({
                                            type: "warning",
                                            message: "请先输入交易密码",
                                            onClose: function () {
                                            }
                                        });
                                        _this.$router.back();
                                        return false;
                                    }
                                    let pwd = _this.isPwdCheck2 ? document.getElementById("privatePwd").value : "";
                                    _this.$req({method: "POST", url: "pef/investor/qualify", timeout: 20000, data: { tradepwd: _this.$util.enc(pwd) }}).then(res => {
                                        if (_this.isPwdCheck2) document.getElementById("privatePwd").value = "";
                                        if (res.code === "0000000") {
                                            if (res.record[0][0].confirmflag === "0") {
                                                _this.$message({
                                                    type: "success",
                                                    message: "您已成功申请为合格投资者，3秒后跳转到转换资料上传页面",
                                                    onClose: function () {
                                                        _this.$router.push({ name: "invdataup", query: {flag: "1"} });
                                                    }
                                                });
                                            }else {
                                                _this.$message({
                                                    type: "success",
                                                    message: "您已成功转换为合格投资者",
                                                    onClose: function () {
                                                    }
                                                });
                                                _this.getBuyWay();
                                            }
                                        }
                                    }).catch(err => {
                                        _this.errStatus = true;
                                        if (_this.isPwdCheck2) document.getElementById("privatePwd").value = "";
                                        _this.$message({
                                            type: "warning",
                                            message: "3秒后将跳转到前一操作页面",
                                            onClose: function () {
                                                _this.$router.back();
                                            }
                                        });
                                    });
                                } else {
                                    if (_this.isPwdCheck2) document.getElementById("privatePwd").value = "";
                                    _this.$router.back();
                                }
                            }
                        });
                    } else {
                        _this.getBuyWay();
                    }
                }
            }).catch(err => {
                _this.errStatus = true;
                _this.$message({
                    type: "warning",
                    message: "3秒后将跳转到前一操作页面",
                    onClose: function () {
                        _this.$router.back();
                    }
                });
            });
        },
        // 处理金额
        isAmount (val) {
            const _val = this.$util.checkAmount(val);
            clearTimeout(this.query);
            this.query = setTimeout(() => {
                this.$set(this.fundInfo, "amount", _val);
                this.queryRate();
            }, 1);
        },
        // 费率入参获取
        queryRate () {
            const _this = this;
            let _d = null;
            if (this.fundInfo.amount > 0 && this.fundInfo.sharetype === "A" && ((this.bankInfo.value && this.fundInfo.way !== "1") || (this.xjbSel.xjbfundcode && this.fundInfo.way === "1")) && this.fund.fundtype !== "2") {
                _d = {
                    fundcode: this.fundInfo.way === "1" ? this.xjbSel.xjbfundcode : this.fund.fundcode,
                    amount: this.fundInfo.amount,
                    channelid: this.fundInfo.way === "1" ? this.xjbSel.channelid : this.bankInfo.value,
                    bizcode: this.fundInfo.way === "1" ? "2" : (this.fundInfo.way === "2" ? "1" : "0"),
                    targetfundcode: this.fundInfo.way === "1" ? this.fund.fundcode : ""
                };
            }
            this.$util.getFee(_d, res => {
                _this.feeGate = res;
                _this.feeH = "<span class=\"red\">" + _this.$util.fmtNum(_this.feeGate.charge) + "元</span>(<s>" + _this.$util.fmtNum(_this.feeGate.originfee) + "</s>元，为您节省<span class=\"red\">" + _this.$util.fmtNum(_this.feeGate.discount) + "</span>元)";
            });
        },
        // 处理限额
        amountLimit (rule, value, callback) {
            this.$util.validateAmountLimit(this, rule, value, callback);
        },
        validatePayWay (rule, value, callback) {
            if (!value && ((this.fundInfo.way === "1" && this.xjbInfo.length > 0) || ((this.fundInfo.way === "2" || this.fundInfo.way === "3") && this.bankLists.length > 0))) {
                callback(new Error("请选择支付方式"));
            } else {
                callback();
            }
        },
        // 再次购买重置表单
        reset () {
            this.buySuccess = false;
            this.bankInfo = {};
            this.$refs.fundInfo.resetFields();
            this.$set(this.fundInfo, "way", "");
            this.getBuyWay();
        },
        // 切换为银行卡支付时数据初始化
        getBank () {
            // 获取银行卡信息
            const _x = this.bankLists[0] ? this.bankLists[0].options[1].moneyaccount : "";
            if (_x) {
                this.$set(this.fundInfo, "pay", _x);
                this.bankSel(_x);
            }
            this.$set(this.limit, "min", this.fund.min);
            this.$set(this.limit, "max", this.fund.max);
            this.pla = this.$util.fmtNum(this.fund.min) + "元起，最多可投" + this.$util.fmtNum(this.fund.max) + "元";
        },
        // 生成确认信息
        resultMes (res) {
            const that = this;
            if (res.data) {
                this.result.cla = "register-success";
                this.result.btnMsg = "预计确认：" + this.$util.fmtDate(res.data[0].incomecaldate) + "， 如遇节假日则顺延，请耐心等待";
            } else {
                this.result.cla = "register-fail";
                this.result.btnMsg = "原因：" + res.msg;
            }
            if (this.fundInfo.way === "3") {
                this.$util.request("umpf/remittance", {status: "3"}).then(res => {
                    if (res.data) {
                        that.result.transfer = {
                            acct_name: res.data[0].acct_name.split(/[,，]/)[0],
                            bankid: res.data[0].bankid.split(/[,，]/)[0],
                            cnaps: res.data[0].cnaps.split(/[,，]/)[0],
                            acct_no: res.data[0].acct_no.split(/[,，]/)[0],
                            big_cnaps: res.data[0].big_cnaps.split(/[,，]/)[0],
                            bank_exchange_no: res.data[0].bank_exchange_no.split(/[,，]/)[0]
                        };
                        that.buySuccess = true;
                    }
                });
                return;
            }
            this.result.msg = "您的" + (this.fundInfo.way === "1" ? "现金宝" : "汇款") + "购买申请已受理" + (this.result.cla === "register-fail" ? "失败" : "成功");
            this.buySuccess = true;
        },
        /* 提交表单数据，校验用户信息 */
        submitInfo (formName) {
            const _this = this;
            _this.$refs[formName].validate(valid => {
                if (valid) {
                    _this.$util.getSdxProtocol(_this.fund,(res)=>{
                        _this.fund = res;
                        _this.protocol = true;
                    });
                } else {
                    return false;
                }
            });
        },
        buyFund(val){
            this.protocol = false;
            if(!val)return;
            const _this = this;
            let _xjbSel = {};
            if (this.fundInfo.way === "1") {
                _xjbSel = this.xjbInfo.filter(item => {
                    return item.transid + item.xjbfundcode === _this.fundInfo.pay;
                })[0];
            }
            // 现金宝不存在，返回
            if (!_xjbSel) {
                return;
            }
            let data = {
                targetfundcode: _this.fund.fundcode,
                targettano: _this.fund.tano,
                targetfundtype: _this.fund.fundtype,
                targetfundname: _this.fund.fundname,
                payway: _this.fundInfo.way,
                riskwarnflag: _this.fund.riskwarnflag,
                riskmismatchflag: _this.fund.riskmismatchflag,
                highriskwarnflag: _this.fund.highriskwarnflag,
                fundmismatchflag: _this.fund.fundmismatchflag,
                channelid: _this.fundInfo.way === "1" ? "" : _this.bankInfo.value,
                moneyaccount: _this.fundInfo.way === "1" ? _xjbSel.moneyaccount : _this.bankInfo.moneyaccount,
                amount: _this.fundInfo.amount,
                sharetype: _this.fundInfo.way === "1" ? _this.xjbInfo[0].sharetype : _this.fundInfo.sharetype,
                tradepwd: _this.$util.enc(_this.fundInfo.pwd)
            };
            if (_this.fundInfo.way === "1") {
                data.fundstatus = _this.fund.fundstatus;
                data.targetsharetype = _this.fundInfo.sharetype;
                data.branchcode = _xjbSel.branchcode;
                data.transactionaccountid = _xjbSel.transid;
                data.xjbfundcode = _xjbSel.xjbfundcode;
            }
            // 下单
            // 提示签署众签协议
            _this.$confirm("请点击确定跳转众签页签署电子合同", "电子合同签署", {
                confirmButtonText: "确认",
                cancelButtonText: "取消",
                type: "info"
            }).then(() => {
                _this.$util.request("acct/cust/contract", {}, "POST", false).then(res => {
                    if (res.data) {
                        let resno = res.data[0].no;
                        _this.$util.newWinOpenSign(JSON.stringify(res.data[0]));
                        _this.$alert("请在签署完成后点击确定进入下一步", "签署确认提示", {
                            confirmButtonText: "确定已签署",
                            type: "warning",
                            center: true,
                            callback: action => {
                                if (action === "confirm") {
                                    _this.$util.request("pef/trade/order", Object.assign({}, data, {zqcontractno: resno}), "POST").then(res => {
                                        _this.resultMes(res);
                                    });
                                }
                            }
                        }).then(() => {
                            return false;
                        }).catch(() => {
                            return false;
                        });
                    }
                });
            });
        },
        // 获取对应银行卡信息
        bankSel (val) {
            const _this = this;
            for (const group of this.bankLists) {
                if (group.options && group.options.length > 0) {
                    for (const bank of group.options) {
                        if (bank.moneyaccount === val) {
                            _this.bankInfo = bank;
                            break;
                        }
                    }
                }
            }
            this.queryRate();
        },
        // 获取基金购买前信息
        getBuyWay () {
            const _this = this;
            this.$req({method: "GET", url: "pef/trade/info", timeout: 20000, params: {fundcode: this.fund.fundcode}}).then(res => {
                if (res.code === "0000000") {
                    const _y = Object.assign({}, res.record[0][0], res.record[3][0]);
                    _this.fund = Object.assign({}, _this.fund, _y);
                    _this.xjbInfo = res.record[1];
                    let _all = 0;
                    _this.xjbInfo.forEach(item => {
                        _all += Number(item.totalasset);
                    });
                    if (_this.fund.payway === "") {
                        _this.$alert("当前基金暂无支持购买的支付方式，暂时无法购买，点击确定返回", "", {
                            confirmButtonText: "确定",
                            type: "warning",
                            callback: action => {
                                this.$router.back();
                            }
                        }).then(() => {
                            return false;
                        }).catch(() => {
                            return false;
                        });
                    }
                    _this.xjbAll = _all;
                    _this.$set(_this.fundInfo, "way", _this.fund.payway.substr(0, 1));
                    _this.$set(_this.fundInfo, "sharetype", _this.fund.sharetype.substr(0, 1));
                    _this.bankLists = res.record[2].length > 0 ? _this.$util.getBankArr(res.record[2],"1") : [];
                }
            }).catch( err => {
                _this.errStatus = true;
                _this.$message({
                    type: "warning",
                    message: "3秒后将跳转到前一操作页面",
                    onClose: function () {
                        _this.$router.back();
                    }
                });
            });
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.bizcomp-private-buy {
    padding-bottom: 30px;
    .fund-market {
        padding: 0 20px;
        .el-table--fit {
            margin-bottom: 0;
        }
    }
    .el-collapse-item__header {
        font-size: $f18;
        color: $color-a;
        border-bottom: 1px solid #ebeef5;
    }
    .private-progress {
        width: 40%;
        display: inline-block;
        margin-right: 20px;
    }
    .progress-text {
        color: $text-color3;
        margin-right: 20px;
        span {
            color: $text-color2;
            &.red {
                color: $color-c;
            }
        }
    }
    .el-collapse-item__content {
        padding-top: 10px;
        .el-col {
            font-size: $f16;
            line-height: 34px;
            span {
                color: $text-color3;
                display: inline-block;
                &:first-of-type {
                    width: 140px;
                    text-align: right;
                }
                &:last-of-type {
                    color: $text-color2;
                }
            }
        }
    }
}
</style>
